/* Klara Olomouc: theme JS (no dependencies) */
(function () {
  'use strict';

  var T = window.theme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};
  var body = document.body;
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(T.locale || 'cs', {
        style: 'currency',
        currency: T.currency || 'CZK',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  /* ---------- announcement bar: seamless marquee + header offset ---------- */
  function initAnnouncement() {
    var bar = qs('[data-announcement]');
    if (!bar) { root.style.setProperty('--announce-h', '0px'); return; }
    var track = qs('[data-announcement-track]', bar);
    var group = qs('[data-announcement-group]', bar);
    var speed = parseFloat(bar.getAttribute('data-speed')) || 40;

    var setHeight = function () { root.style.setProperty('--announce-h', bar.offsetHeight + 'px'); };

    var build = function () {
      if (!track || !group || reduceMotion) { setHeight(); return; }
      qsa('[data-clone]', track).forEach(function (el) { el.parentNode.removeChild(el); });
      var width = group.getBoundingClientRect().width;
      if (!width) { setHeight(); return; }
      var copies = Math.max(1, Math.ceil(window.innerWidth / width));
      for (var i = 1; i < copies * 2; i++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.removeAttribute('data-announcement-group');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      bar.style.setProperty('--marquee-duration', (width * copies / speed) + 's');
      bar.classList.add('is-marquee');
      setHeight();
    };

    build();
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(build); }
    window.addEventListener('resize', debounce(build, 200));
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = qs('[data-header]');
    if (!header) return;
    if (body.classList.contains('has-hero') && !qs('#MainContent .hero')) {
      body.classList.remove('has-hero');
    }
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    if (!header.__scrollBound) {
      header.__scrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    onScroll();
  }

  /* ---------- drawers (menu, cart), search overlay ---------- */
  var lastFocus = null;

  function setMenu(open) {
    var menu = qs('[data-mobile-menu]');
    var was = body.classList.contains('menu-open');
    body.classList.toggle('menu-open', open);
    if (menu) { menu.setAttribute('aria-hidden', open ? 'false' : 'true'); }
    if (open && menu) {
      var closeBtn = qs('[data-close-menu]', menu);
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    } else if (was && lastFocus) {
      lastFocus.focus();
    }
  }

  function setCart(open) {
    var drawer = qs('.cart-drawer');
    var was = body.classList.contains('cart-open');
    body.classList.toggle('cart-open', open);
    if (drawer) { drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); }
    if (open && drawer) {
      var closeBtn = qs('[data-close-cart]', drawer);
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    } else if (was && lastFocus) {
      lastFocus.focus();
    }
  }

  function setSearch(open) {
    var overlay = qs('[data-search-overlay]');
    if (!overlay) return;
    var was = overlay.classList.contains('is-open');
    overlay.classList.toggle('is-open', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('search-open', open);
    if (open) {
      var input = qs('[data-search-input]', overlay);
      if (input) setTimeout(function () { input.focus(); }, 120);
    } else if (was && lastFocus) {
      lastFocus.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-menu]')) { e.preventDefault(); lastFocus = t.closest('[data-open-menu]'); setMenu(true); return; }
    if (t.closest('[data-close-menu]')) { e.preventDefault(); setMenu(false); return; }
    if (t.closest('.mobile-menu a')) { setMenu(false); return; }
    if (t.closest('[data-open-cart]')) { e.preventDefault(); lastFocus = t.closest('[data-open-cart]'); setCart(true); return; }
    if (t.closest('[data-close-cart]')) { e.preventDefault(); setCart(false); return; }
    if (t.closest('[data-open-search]')) { e.preventDefault(); lastFocus = t.closest('[data-open-search]'); setSearch(true); return; }
    if (t.closest('[data-close-search]')) { e.preventDefault(); setSearch(false); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setMenu(false); setCart(false); setSearch(false);
    /* close a category panel that is open through keyboard focus */
    var active = document.activeElement;
    if (active && active.closest && active.closest('.site-nav')) active.blur();
  });

  /* ---------- cart ---------- */
  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshDrawer() {
    return fetch(routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var holder = qs('#shopify-section-cart-drawer');
        if (!holder || !data['cart-drawer']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var fresh = qs('.cart-drawer-root', tmp);
        var current = qs('.cart-drawer-root', holder);
        if (fresh && current) current.replaceWith(fresh);
        var countEl = qs('[data-drawer-count]', holder);
        if (countEl) updateCount(countEl.getAttribute('data-drawer-count'));
      });
  }

  function addToCart(payload) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { throw data; }
        return data;
      });
    }).then(refreshDrawer).then(function () { setCart(true); });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .then(function () {
        if (body.classList.contains('template-cart')) window.location.reload();
      });
  }

  function errorText(err) {
    if (err && (err.description || err.message)) return err.description || err.message;
    return strings.genericError || '';
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var id = parseInt(quick.getAttribute('data-quick-add'), 10);
      if (!id || quick.disabled) return;
      var label = quick.textContent;
      quick.disabled = true;
      addToCart({ id: id, quantity: 1 }).then(function () {
        quick.textContent = strings.added || label;
        setTimeout(function () { quick.textContent = label; quick.disabled = false; }, 1600);
      }).catch(function () { quick.disabled = false; });
      return;
    }

    var step = e.target.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-key'), Math.max(0, parseInt(step.getAttribute('data-cart-step'), 10)));
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-key'), 0);
      return;
    }
    var upsell = e.target.closest('[data-upsell-add]');
    if (upsell && !upsell.disabled) {
      e.preventDefault();
      var uid = parseInt(upsell.getAttribute('data-id'), 10);
      if (!uid) return;
      upsell.disabled = true;
      addToCart({ id: uid, quantity: 1 }).catch(function () { upsell.disabled = false; });
    }
  });

  /* ---------- hero slideshow ---------- */
  function initHero(scope) {
    qsa('[data-hero]', scope).forEach(function (hero) {
      if (hero.__ready) return;
      hero.__ready = true;
      var slides = qsa('.hero__slide', hero);
      var texts = qsa('.hero__text', hero);
      var dots = qsa('.hero__dot', hero);
      if (slides.length < 2) return;
      var seconds = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var index = 0;
      var timer = null;

      var show = function (i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        texts.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      var start = function () {
        stop();
        if (seconds > 0 && !reduceMotion && !designMode) {
          timer = setInterval(function () { show(index + 1); }, seconds * 1000);
        }
      };
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { show(n); start(); });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
      start();
    });
  }

  /* ---------- carousel (native scroll-snap + arrows) ---------- */
  function initCarousels(scope) {
    qsa('[data-carousel]', scope).forEach(function (sec) {
      if (sec.__ready) return;
      var viewport = qs('[data-carousel-viewport]', sec);
      var prev = qs('[data-carousel-prev]', sec);
      var next = qs('[data-carousel-next]', sec);
      var stage = qs('.featured__stage', sec);
      if (!viewport) return;
      sec.__ready = true;

      var cardStep = function () {
        var card = qs('.product-card', viewport);
        if (!card) return viewport.clientWidth;
        var gap = parseFloat(getComputedStyle(card.parentNode).columnGap) || 20;
        return card.getBoundingClientRect().width + gap;
      };
      var update = function () {
        var max = viewport.scrollWidth - viewport.clientWidth;
        var overflow = max > 4;
        [prev, next].forEach(function (b) { if (b) b.hidden = !overflow; });
        if (prev) prev.disabled = viewport.scrollLeft <= 2;
        if (next) next.disabled = viewport.scrollLeft >= max - 2;
      };
      var centerArrows = function () {
        var media = qs('.product-card__media', viewport);
        if (!media || !stage) return;
        var top = media.getBoundingClientRect().top - stage.getBoundingClientRect().top + media.offsetHeight / 2;
        [prev, next].forEach(function (b) { if (b) b.style.top = top + 'px'; });
      };
      var move = function (dir) {
        var step = cardStep();
        var visible = Math.max(1, Math.floor(viewport.clientWidth / step));
        var count = Math.max(1, visible - (visible > 2 ? 1 : 0));
        viewport.scrollBy({ left: dir * step * count, behavior: reduceMotion ? 'auto' : 'smooth' });
      };

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      viewport.addEventListener('scroll', debounce(update, 40), { passive: true });
      window.addEventListener('resize', debounce(function () { update(); centerArrows(); }, 150));
      window.addEventListener('load', function () { update(); centerArrows(); });
      update();
      centerArrows();
      setTimeout(function () { update(); centerArrows(); }, 600);
    });
  }

  /* ---------- product page ---------- */
  function initProducts(scope) {
    qsa('[data-product-form]', scope).forEach(function (rootEl) {
      if (rootEl.__ready) return;
      var dataEl = qs('[data-product-json]', rootEl);
      var form = qs('[data-product-form-el]', rootEl);
      if (!dataEl || !form) return;
      rootEl.__ready = true;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var section = rootEl.closest('[data-product-section]') || document;
      var optionNames = (data.options || []).map(function (o) { return String(o.name || o); });
      var variants = data.variants || [];
      var idInput = qs('[data-variant-id]', form);
      var submitBtn = qs('[data-add-button]', form);
      var errorEl = qs('[data-form-error]', form);
      var qtyInput = qs('[data-qty-input]', form);
      var priceEl = qs('[data-price]', rootEl);
      var compareEl = qs('[data-compare-price]', rootEl);
      var discountEl = qs('[data-discount]', rootEl);
      var saveEl = qs('[data-save]', rootEl);
      var sticky = qs('[data-sticky-atc]', section);
      var stickyPrice = sticky ? qs('[data-sticky-price]', sticky) : null;
      var stickyBtn = sticky ? qs('[data-sticky-btn]', sticky) : null;
      var gallery = qs('.product-gallery', section);
      var thumbs = gallery ? qsa('[data-pg-thumb]', gallery) : [];
      var mainImg = gallery ? qs('[data-pg-main-img]', gallery) : null;
      var mainLink = gallery ? qs('[data-pg-main]', gallery) : null;
      var track = gallery ? qs('[data-pg-track]', gallery) : null;
      var upBtn = gallery ? qs('[data-pg-up]', gallery) : null;
      var downBtn = gallery ? qs('[data-pg-down]', gallery) : null;
      var addLabel = submitBtn ? submitBtn.textContent.trim() : (strings.addToCart || '');
      var soldLabel = strings.soldOut || '';
      var selected = {};
      var firstRender = true;

      /* start from the variant that is currently selected */
      var current = variants.filter(function (v) { return String(v.id) === (idInput ? idInput.value : ''); })[0] || variants[0];
      if (current) optionNames.forEach(function (name, i) { selected[name] = current.options[i]; });

      var matches = function (v, ignoreName) {
        return optionNames.every(function (name, i) {
          if (name === ignoreName) return true;
          var val = selected[name];
          return !val || v.options[i] === val;
        });
      };
      var findVariant = function () {
        var exact = variants.filter(function (v) { return matches(v) && v.available; })[0]
          || variants.filter(function (v) { return matches(v); })[0];
        return exact || current;
      };
      var isValueAvailable = function (name, value) {
        var i = optionNames.indexOf(name);
        return variants.some(function (v) {
          return v.options[i] === value && v.available && matches(v, name);
        });
      };

      /* gallery */
      var setMain = function (thumb) {
        if (!thumb || !mainImg) return;
        mainImg.setAttribute('src', thumb.getAttribute('data-full') || '');
        mainImg.setAttribute('srcset', thumb.getAttribute('data-srcset') || '');
        mainImg.setAttribute('alt', thumb.getAttribute('data-alt') || '');
        if (mainLink) mainLink.setAttribute('href', thumb.getAttribute('data-zoom') || thumb.getAttribute('data-full') || '');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        if (track && window.innerWidth >= 768) {
          var top = thumb.offsetTop - track.offsetTop;
          if (top < track.scrollTop || top + thumb.offsetHeight > track.scrollTop + track.clientHeight) {
            track.scrollTop = Math.max(0, top - 8);
          }
        }
      };
      var updateArrows = function () {
        if (!track) return;
        var overflow = track.scrollHeight - track.clientHeight > 4;
        [upBtn, downBtn].forEach(function (b) { if (b) b.style.display = overflow ? '' : 'none'; });
        if (upBtn) upBtn.disabled = track.scrollTop <= 2;
        if (downBtn) downBtn.disabled = track.scrollTop >= track.scrollHeight - track.clientHeight - 2;
      };
      var syncHeight = function () {
        if (!track) return;
        if (window.innerWidth < 768) { track.style.maxHeight = ''; updateArrows(); return; }
        var main = mainLink || mainImg;
        if (main) {
          var h = main.getBoundingClientRect().height;
          var pad = (upBtn ? upBtn.offsetHeight + 8 : 0) + (downBtn ? downBtn.offsetHeight + 8 : 0);
          if (h > 40) track.style.maxHeight = Math.max(120, h - pad) + 'px';
        }
        updateArrows();
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(t); }); });
      if (upBtn) upBtn.addEventListener('click', function () { track.scrollTop -= Math.max(120, track.clientHeight * 0.7); updateArrows(); });
      if (downBtn) downBtn.addEventListener('click', function () { track.scrollTop += Math.max(120, track.clientHeight * 0.7); updateArrows(); });
      if (track) track.addEventListener('scroll', updateArrows, { passive: true });
      if (mainImg) mainImg.addEventListener('load', syncHeight);
      window.addEventListener('resize', debounce(syncHeight, 150));
      if (window.ResizeObserver && (mainLink || mainImg)) {
        try { new ResizeObserver(syncHeight).observe(mainLink || mainImg); } catch (err) { /* ignore */ }
      }
      syncHeight();
      setTimeout(syncHeight, 400);

      /* render the chosen variant everywhere */
      var render = function () {
        var variant = findVariant();
        if (!variant) return;
        current = variant;
        optionNames.forEach(function (name, i) { selected[name] = variant.options[i]; });
        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price); }
        if (discountEl) {
          discountEl.hidden = !onSale;
          if (onSale) discountEl.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + ' %';
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          var saveTpl = saveEl.getAttribute('data-template');
          if (onSale && saveTpl) {
            saveEl.textContent = saveTpl.replace('__AMOUNT__', formatMoney(variant.compare_at_price - variant.price));
          }
        }

        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available ? addLabel : soldLabel;
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (stickyBtn) {
          stickyBtn.disabled = !variant.available;
          stickyBtn.textContent = variant.available ? addLabel : soldLabel;
        }

        qsa('[data-option-value]', rootEl).forEach(function (btn) {
          var name = btn.getAttribute('data-option-name');
          var value = btn.getAttribute('data-option-value');
          var isSel = selected[name] === value;
          btn.classList.toggle('is-selected', isSel);
          btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
          btn.disabled = !isValueAvailable(name, value) && !isSel;
          if (isSel) {
            var label = qs('[data-selected-label="' + name.replace(/"/g, '\\"') + '"]', rootEl);
            if (label) label.textContent = '— ' + value;
          }
        });

        if (variant.image_id && thumbs.length) {
          var thumb = thumbs.filter(function (t) { return t.getAttribute('data-image-id') === String(variant.image_id); })[0];
          if (thumb) setMain(thumb);
        }

        if (!firstRender && window.history && history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            history.replaceState({}, '', url.toString());
          } catch (err) { /* ignore */ }
        }
        firstRender = false;
      };

      rootEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        selected[btn.getAttribute('data-option-name')] = btn.getAttribute('data-option-value');
        render();
      });

      /* quantity */
      rootEl.addEventListener('click', function (e) {
        var stepBtn = e.target.closest('[data-qty-step]');
        if (!stepBtn || !qtyInput) return;
        var v = (parseInt(qtyInput.value, 10) || 1) + parseInt(stepBtn.getAttribute('data-qty-step'), 10);
        qtyInput.value = Math.min(99, Math.max(1, v));
      });
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          qtyInput.value = Math.min(99, Math.max(1, parseInt(qtyInput.value, 10) || 1));
        });
      }

      /* personalisation: uppercase while typing */
      qsa('[data-perso-input]', form).forEach(function (inp) {
        inp.addEventListener('input', function () {
          inp.classList.remove('is-invalid');
          if (errorEl) { errorEl.hidden = true; }
        });
      });

      var showError = function (msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.hidden = false;
      };

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput || !idInput.value || (submitBtn && submitBtn.disabled)) return;
        if (errorEl) errorEl.hidden = true;

        var props = {};
        var invalid = null;
        qsa('[name^="properties["]', form).forEach(function (inp) {
          var m = inp.name.match(/^properties\[(.+)\]$/);
          var val = (inp.value || '').trim();
          if (inp.required && !val) { inp.classList.add('is-invalid'); if (!invalid) invalid = inp; return; }
          if (m && val) props[m[1]] = inp.hasAttribute('data-perso-input') ? val.toUpperCase() : val;
        });
        if (invalid) {
          showError(strings.required || '');
          invalid.focus();
          try { invalid.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { /* ignore */ }
          return;
        }

        var payload = { id: parseInt(idInput.value, 10), quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1 };
        if (Object.keys(props).length) payload.properties = props;

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = strings.adding || addLabel; }
        addToCart(payload).then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = strings.added || addLabel;
            setTimeout(function () { render(); }, 1800);
          }
        }).catch(function (err) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = addLabel; }
          showError(errorText(err));
        });
      });

      /* sticky add-to-cart bar */
      if (sticky && submitBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        }, { threshold: 0 });
        io.observe(submitBtn);
      }
      if (stickyBtn && submitBtn) {
        stickyBtn.addEventListener('click', function () { submitBtn.click(); });
      }

      render();
    });
  }

  /* ---------- gallery lightbox ---------- */
  var lightbox = null;
  function openLightbox(src) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'pg-lightbox';
      lightbox.innerHTML = '<img alt="">';
      lightbox.addEventListener('click', closeLightbox);
      document.body.appendChild(lightbox);
    }
    qs('img', lightbox).src = src;
    lightbox.classList.add('is-open');
    body.classList.add('dialog-open');
  }
  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('is-open');
    body.classList.remove('dialog-open');
  }
  document.addEventListener('click', function (e) {
    var zoom = e.target.closest('[data-gallery-zoom]');
    if (!zoom) return;
    e.preventDefault();
    openLightbox(zoom.getAttribute('href'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  /* ---------- size guide dialog ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-size-guide-open]');
    var dialog = qs('[data-size-guide]');
    if (open && dialog) {
      e.preventDefault();
      if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
      body.classList.add('dialog-open');
      return;
    }
    if (dialog && (e.target.closest('[data-size-guide-close]') || e.target === dialog)) {
      if (typeof dialog.close === 'function') { dialog.close(); } else { dialog.removeAttribute('open'); }
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-size-guide]')) body.classList.remove('dialog-open');
  }, true);

  /* ---------- search suggestions ---------- */
  function initSearch() {
    var overlay = qs('[data-search-overlay]');
    if (!overlay || overlay.__ready) return;
    overlay.__ready = true;
    var input = qs('[data-search-input]', overlay);
    var results = qs('[data-search-results]', overlay);
    if (!input || !results) return;

    var toUnits = function (raw) {
      var s = String(raw == null ? '' : raw);
      var n = parseFloat(s);
      if (isNaN(n)) return null;
      return s.indexOf('.') >= 0 ? n : n / 100;
    };

    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      var url = (routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            var msg = String(strings.noResults || '').replace('__TERMS__', escapeHtml(q));
            results.innerHTML = '<p class="search-overlay__empty">' + msg + '</p>';
            return;
          }
          var html = products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            var units = toUnits(p.price);
            var price = units === null ? '' : formatMoney(Math.round(units * 100));
            return '<a class="search-result" href="' + escapeHtml(p.url) + '">' +
              (img ? '<img class="search-result__img" src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '<span class="search-result__img"></span>') +
              '<span class="search-result__info"><p class="search-result__title">' + escapeHtml(p.title) + '</p>' +
              (price ? '<p class="search-result__price">' + escapeHtml(price) + '</p>' : '') + '</span></a>';
          }).join('');
          html += '<a class="search-overlay__all" href="' + escapeHtml((routes.search || '/search') + '?type=product&q=' + encodeURIComponent(q)) + '">' + escapeHtml(strings.allResults || '') + '</a>';
          results.innerHTML = html;
        })
        .catch(function () { /* ignore */ });
    }, 220));
  }

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-select]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- related products (loaded when scrolled into view) ---------- */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var load = function () {
          fetch(self.dataset.url)
            .then(function (r) { return r.text(); })
            .then(function (text) {
              var holder = document.createElement('div');
              holder.innerHTML = text;
              var fresh = holder.querySelector('product-recommendations');
              if (fresh && fresh.innerHTML.trim().length) self.innerHTML = fresh.innerHTML;
            })
            .catch(function () { /* ignore */ });
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries, obs) {
            if (entries[0].isIntersecting) { obs.unobserve(self); load(); }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(self);
        } else {
          load();
        }
      }
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    if (designMode || reduceMotion || !('IntersectionObserver' in window)) return;
    var targets = qsa('.cat-tiles, .trust-bar, .featured, .story, .faq, .social, .product-accordion, .related-products__section', scope);
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (el) {
      if (el.classList.contains('reveal')) return;
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  /* ---------- withdrawal form (2 steps: fill in, then confirm) ---------- */
  function initWithdrawal(scope) {
    qsa('[data-withdrawal]', scope).forEach(function (wd) {
      var step1 = qs('[data-wd-step="1"]', wd);
      var step2 = qs('[data-wd-step="2"]', wd);
      var next = qs('[data-wd-next]', wd);
      var form = qs('form', wd);
      if (!step1 || !step2 || !next || !form || wd.__wdBound) return;
      wd.__wdBound = true;
      var fields = { name: qs('#wd-name', wd), email: qs('#wd-email', wd), order: qs('#wd-order', wd), items: qs('#wd-items', wd) };
      var summary = qs('[data-wd-summary]', wd);
      var bodyField = qs('[data-wd-body]', wd);
      var d = wd.dataset;

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function stamp() {
        var n = new Date();
        return n.getDate() + '. ' + (n.getMonth() + 1) + '. ' + n.getFullYear() + ' ' + pad(n.getHours()) + ':' + pad(n.getMinutes());
      }
      function rows() {
        return [
          [d.lName, fields.name.value.trim()],
          [d.lEmail, fields.email.value.trim()],
          [d.lOrder, fields.order.value.trim()],
          [d.lItems, fields.items.value.trim() || d.lAll]
        ];
      }
      function show(step) {
        step1.hidden = step !== 1;
        step2.hidden = step !== 2;
        var heading = qs('h2', step === 1 ? step1 : step2);
        if (heading) heading.focus();
      }

      next.addEventListener('click', function () {
        var valid = ['name', 'email', 'order'].every(function (key) {
          if (fields[key].checkValidity()) return true;
          fields[key].reportValidity();
          return false;
        });
        if (!valid) return;
        summary.innerHTML = rows().map(function (r) {
          return '<div><dt>' + escapeHtml(r[0]) + '</dt><dd>' + escapeHtml(r[1]) + '</dd></div>';
        }).join('');
        show(2);
      });
      qs('[data-wd-back]', wd).addEventListener('click', function () { show(1); });
      form.addEventListener('submit', function () {
        var lines = [d.title, ''].concat(rows().map(function (r) { return r[0] + ': ' + r[1]; }));
        lines.push(d.lSent + ': ' + stamp(), '', d.statement);
        bodyField.value = lines.join('\n');
      });
    });
  }

  /* ---------- init ---------- */
  function initAll(scope) {
    initHero(scope);
    initCarousels(scope);
    initProducts(scope);
    initReveal(scope);
    initWithdrawal(scope);
  }

  initAnnouncement();
  initHeader();
  initSearch();
  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initAnnouncement();
    initHeader();
    initSearch();
  });
})();
